import constants from "../Utils/constants";
const initialState = {
  leads: [],
  lead_typs: [],
  isGetLeadsLoading: false,
  isCreateLeadLoading: false,
  isUpdateLeadLoading: false,
  isDeleteLeadLoading: false,
  isGetLeadTypeLoading: false,
  totalLength: 0,
  totalPages: 0,
  currentPage: 1,
  statusCounts: {
    all: 0,
    Hot: 0,
    Cold: 0,
    Warm: 0,
    Dead: 0,
    Success: 0
  }
};

const leadsReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_LEADS_REQUEST:
      return {
        ...state,
        isGetLeadsLoading: true,
      };
    case constants.GET_LEADS_SUCCESS:
      const isPaginated = action.payload && !Array.isArray(action.payload);
      return {
        ...state,
        isGetLeadsLoading: false,
        leads: isPaginated ? (action.payload.leads || []) : (action.payload || []),
        totalLength: isPaginated ? (action.payload.total_length || 0) : (action.payload?.length || 0),
        totalPages: isPaginated ? (action.payload.total_pages || 1) : 1,
        currentPage: isPaginated ? (action.payload.current_page || 1) : 1,
        statusCounts: isPaginated ? (action.payload.status_counts || initialState.statusCounts) : initialState.statusCounts,
      };
    case constants.GET_LEADS_FAILURE:
      return {
        ...state,
        isGetLeadsLoading: false,
      };
    case constants.GET_LEAD_TYPES_REQUEST:
      return {
        ...state,
        isGetLeadTypeLoading: true,
      };
    case constants.GET_LEAD_TYPES_SUCCESS:
      return {
        ...state,
        lead_typs: action.payload,
        isGetLeadTypeLoading: false,
      };
    case constants.GET_LEAD_TYPES_FAILURE:
      return {
        ...state,
        isGetLeadTypeLoading: false,
      };


    case constants.GET_LEAD_BY_ID_REQUEST:
      return {
        ...state,
        isGetLeadByIdLoading: true,
      };
    case constants.GET_LEAD_BY_ID_SUCCESS:
      return {
        ...state,
        isGetLeadByIdLoading: false,
      };
    case constants.GET_LEAD_BY_ID_FAILURE:
      return {
        ...state,
        isGetLeadByIdLoading: false,
      };

    case constants.CREATE_LEAD_REQUEST:
      return {
        ...state,
        isCreateLeadLoading: true,
      };
    case constants.CREATE_LEAD_SUCCESS:
      return {
        ...state,
        isCreateLeadLoading: false,
      };
    case constants.CREATE_LEAD_FAILURE:
      return {
        ...state,
        isCreateLeadLoading: false,
      };

    case constants.UPDATE_LEAD_REQUEST:
      return {
        ...state,
        isUpdateLeadLoading: true,
      };
    case constants.UPDATE_LEAD_SUCCESS:
      return {
        ...state,
        isUpdateLeadLoading: false,
      };
    case constants.UPDATE_LEAD_FAILURE:
      return {
        ...state,
        isUpdateLeadLoading: false,
      };

    case constants.DELETE_LEAD_REQUEST:
      return {
        ...state,
        isDeleteLeadLoading: true,
      };
    case constants.DELETE_LEAD_SUCCESS:
      return {
        ...state,
        isDeleteLeadLoading: false,
      };
    case constants.DELETE_LEAD_FAILURE:
      return {
        ...state,
        isDeleteLeadLoading: false,
      };
    case "REMOVING_USER_CREDENTIALS":
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
export default leadsReducer;
